export const isMarketplaceTrackerActive = (flags: any) => {
  if (Array.isArray(flags)) {
    const trackerFlag = flags.find(
      (flag) =>
        flag?.key === 'marketplaceTrackerActive' ||
        flag?.name === 'marketplaceTrackerActive'
    )

    return trackerFlag?.value === true
  }

  return flags?.marketplaceTrackerActive === true
}
